module.exports = __webpack_public_path__ + "static/img/exhibitor_diamond_en.fb6744f3.png";